export default class timezonesController {
  constructor() { }
}

 timezonesController.$inject = [];



// WEBPACK FOOTER //
// ./src/app/components/timezones/timezones.controller.js